import * as React from 'react'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import { getVerticalName, Vertical } from 'common/constants'
import { KeyCode } from 'common/constants/keyCode'
import hostConfig from 'common/config'
import * as s from './lnbSearch.scss'

interface State {
  searchKeyword: string
  opened: boolean
}

interface OwnProps {
  vertical?: Vertical
  cx?: DynamicCx
}

type Props = OwnProps

@styling(s)
export default class LnbSearch extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      searchKeyword: '',
      opened: false,
    }
  }

  handleChangeSearchKeyword = e => this.setState({ searchKeyword: e.target.value })
  handleClickOpenButton = () => this.setState({ opened: true })
  handleClickCloseButton = () => this.setState({ opened: false })
  handleClickSearchButton = () => this.search()
  handleKeyDown = e => {
    if (e.keyCode !== KeyCode.ENTER) return
    this.search()
  }

  search = () => {
    const { vertical } = this.props
    const { searchKeyword } = this.state
    if (!searchKeyword || searchKeyword.length === 0) {
      alert('검색어를 입력해주세요.')
      return
    }
    window.location.assign(
      `${hostConfig.shoppingSearchUri.pc}/search/all.nhn?${
        vertical ? `vertical=${vertical.toLowerCase()}&` : ''
      }query=${encodeURIComponent(searchKeyword)}`,
    )
  }

  render() {
    const { vertical, cx } = this.props
    const { searchKeyword, opened } = this.state
    return (
      <>
        <a href="javascript:void(0)" className={cx('btn_search_open')} onClick={this.handleClickOpenButton}>
          검색영역 보기
        </a>
        <div className={cx('search_area', { active: opened })}>
          <div className={cx('inner')}>
            <fieldset>
              <legend>서비스 내 검색</legend>
              <input
                type="text"
                className={cx('search_input')}
                title="검색어 입력"
                placeholder={`${getVerticalName(vertical) || ''} 검색`}
                value={searchKeyword}
                onChange={this.handleChangeSearchKeyword}
                onKeyDown={this.handleKeyDown}
              />
              <a href="javascript:void(0)" className={cx('btn_search')} onClick={this.handleClickSearchButton}>
                검색
              </a>
            </fieldset>
          </div>
          <a
            href="javascript:void(0)"
            type="button"
            className={cx('btn_search_close')}
            onClick={this.handleClickCloseButton}>
            검색영역 닫기
          </a>
        </div>
      </>
    )
  }
}
